const withdrawalConst = {
  formTypeOptions: ['Withdrawal', 'Graduation'],
}

export default withdrawalConst
